import React from 'react';

import { ENUM_ACTIVE_CHECKBOX, ENUM_IMAGE_LAYOUT, ENUM_QUESTION_TYPE, ENUM_SURVEY_TYPE, ENUM_TYPE_QUESTION } from 'constants/enum';

import {
  MESSAGE_CONTROL_IMAGE,
  MESSAGE_CONTROL_QUESTION_COMMON,
  MESSAGE_CONTROL_QUESTION_DATE,
  MESSAGE_MOTOR_SKILLS,
  MESSAGE_SURVEY_AGE,
  MESSAGE_SURVEY_TYPE,
  MESSAGE_TYPE_QUESTION,
} from './string/messages';

const CHECK_BOX_ICON = require('assets/resources/CheckBox.svg').default;
const DELETE_ICON = require('assets/resources/DeleteOutline.svg').default;
const EVENT_ICON = require('assets/resources/Event.svg').default;
const EXPAND_CIRCLE_DOWN_ICON = require('assets/resources/ExpandCircleDown.svg').default;
const ALIGN_CENTER_ICON = require('assets/resources/FormatAlignCenter.svg').default;
const ALIGN_LEFT_ICON = require('assets/resources/FormatAlignLeft.svg').default;
const ALIGN_RIGHT_ICON = require('assets/resources/FormatAlignRight.svg').default;
const NOTE_ICON = require('assets/resources/Note.svg').default;
const RADIO_BUTTON_CHECKED_ICON = require('assets/resources/RadioButtonChecked.svg').default;
const SHORT_TEXT_ICON = require('assets/resources/ShortText.svg').default;

export const type_question = [
  {
    key: 'short_text',
    value: ENUM_QUESTION_TYPE.DESCRIPTIVE_SHORT_ESSAY,
  },
  {
    key: 'paragraph',
    value: ENUM_QUESTION_TYPE.PARAGRAPH,
  },
  {
    key: 'radio',
    value: ENUM_QUESTION_TYPE.RADIO,
  },
  {
    key: 'checkbox',
    value: ENUM_QUESTION_TYPE.CHECKBOX,
  },
  {
    key: 'dropdown',
    value: ENUM_QUESTION_TYPE.DROPDOWN,
  },
  {
    key: 'date',
    value: ENUM_QUESTION_TYPE.DATE,
  },
];

export const LIST_TYPE_QUESTION = [
  {
    text: MESSAGE_TYPE_QUESTION.DESCRIPTIVE_SHORT_ESSAY,
    value: ENUM_QUESTION_TYPE.DESCRIPTIVE_SHORT_ESSAY,
    icon: (
      <React.Fragment>
        <img src={SHORT_TEXT_ICON} alt="short text" width={18} height={18} />
      </React.Fragment>
    ),
  },
  {
    text: MESSAGE_TYPE_QUESTION.PARAGRAPH,
    value: ENUM_QUESTION_TYPE.PARAGRAPH,
    icon: (
      <React.Fragment>
        <img src={NOTE_ICON} alt="note" width={18} height={18} />
      </React.Fragment>
    ),
    divider: true,
  },
  {
    text: MESSAGE_TYPE_QUESTION.RADIO,
    value: ENUM_QUESTION_TYPE.RADIO,
    icon: (
      <React.Fragment>
        <img src={RADIO_BUTTON_CHECKED_ICON} alt="radio button checked" width={18} height={18} />
      </React.Fragment>
    ),
  },
  {
    text: MESSAGE_TYPE_QUESTION.CHECKBOX,
    value: ENUM_QUESTION_TYPE.CHECKBOX,
    icon: (
      <React.Fragment>
        <img src={CHECK_BOX_ICON} alt="check box" width={18} height={18} />
      </React.Fragment>
    ),
  },
  {
    text: MESSAGE_TYPE_QUESTION.DROPDOWN,
    value: ENUM_QUESTION_TYPE.DROPDOWN,
    icon: (
      <React.Fragment>
        <img src={EXPAND_CIRCLE_DOWN_ICON} alt="expand circle down" width={18} height={18} />
      </React.Fragment>
    ),
    divider: true,
  },
  {
    text: MESSAGE_TYPE_QUESTION.DATE,
    value: ENUM_QUESTION_TYPE.DATE,
    icon: (
      <React.Fragment>
        <img src={EVENT_ICON} alt="event" width={18} height={18} />
      </React.Fragment>
    ),
  },
];

export const LIST_CONTROL_IMAGE = [
  {
    text: MESSAGE_CONTROL_IMAGE.ALIGN_LEFT,
    value: ENUM_IMAGE_LAYOUT.LEFT,
    icon: (
      <React.Fragment>
        <img src={ALIGN_LEFT_ICON} alt="align text left" width={12} height={12} />
      </React.Fragment>
    ),
  },
  {
    text: MESSAGE_CONTROL_IMAGE.ALIGN_CENTER,
    value: ENUM_IMAGE_LAYOUT.CENTER,
    icon: (
      <React.Fragment>
        <img src={ALIGN_CENTER_ICON} alt="align text center" width={12} height={12} />
      </React.Fragment>
    ),
  },
  {
    text: MESSAGE_CONTROL_IMAGE.ALIGN_RIGHT,
    value: ENUM_IMAGE_LAYOUT.RIGHT,
    icon: (
      <React.Fragment>
        <img src={ALIGN_RIGHT_ICON} alt="align text right" width={12} height={12} />
      </React.Fragment>
    ),
  },
  {
    text: MESSAGE_CONTROL_IMAGE.DELETE,
    value: 'delete',
    icon: (
      <React.Fragment>
        <img src={DELETE_ICON} alt="delete" width={12} height={12} />
      </React.Fragment>
    ),
  },
];

export const LIST_CONTROL_QUESTION_COMMON = [
  {
    text: MESSAGE_CONTROL_QUESTION_COMMON.EXPLANATION,
    value: ENUM_ACTIVE_CHECKBOX.EXPLANATION,
  },
];

export const LIST_CONTROL_QUESTION_DATE = [
  {
    text: MESSAGE_CONTROL_QUESTION_DATE.INCLUDE_YEAR,
    value: ENUM_ACTIVE_CHECKBOX.INCLUDE_YEAR,
  },
];

export const LIST_CONTROL_QUESTION = [...LIST_CONTROL_QUESTION_COMMON, ...LIST_CONTROL_QUESTION_DATE];

export const TIME_RESEND_EMAIL_SECOND = 60;

export const OPTION_PAGINATION = {
  total: 0,
  page: 1,
  page_size: 10,
};

export const FORMAT_TIME = {
  MONTH_DAY: 'MM/DD',
  DATE: 'YYYY/MM/DD',
  MONTH_DAY_SOLID: 'MM-DD',
  DATE_SOLID: 'YYYY-MM-DD',
  DATE_TIME: 'YYYY/MM/DD HH:mm',
  FULL_DATE_TIME: 'YYYY/MM/DD HH:mm:ss',
};

export const LIST_TYPE_SURVEY = [
  {
    text: MESSAGE_SURVEY_AGE.TWO_WEEKS_OLD,
    value: ENUM_TYPE_QUESTION.TWO_WEEKS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.ONE_MONTH_OLD,
    value: ENUM_TYPE_QUESTION.ONE_MONTH_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.TWO_MONTHS_OLD,
    value: ENUM_TYPE_QUESTION.TWO_MONTHS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.FIVE_MONTHS_OLD,
    value: ENUM_TYPE_QUESTION.FIVE_MONTHS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.SIX_SEVEN_MONTHS_OLD,
    value: ENUM_TYPE_QUESTION.SIX_SEVEN_MONTHS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.EIGHT_MONTHS_OLD,
    value: ENUM_TYPE_QUESTION.EIGHT_MONTHS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.NINE_TEN_MONTHS_OLD,
    value: ENUM_TYPE_QUESTION.NINE_TEN_MONTHS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.ELEVEN_MONTHS_OLD,
    value: ENUM_TYPE_QUESTION.ELEVEN_MONTHS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.ONE_YEAR_OLD,
    value: ENUM_TYPE_QUESTION.ONE_YEAR_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.ONE_YEAR_SIX_MONTHS_OLD,
    value: ENUM_TYPE_QUESTION.ONE_YEAR_SIX_MONTHS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.TWO_YEARS_OLD,
    value: ENUM_TYPE_QUESTION.TWO_YEARS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.THREE_YEAR_OLD,
    value: ENUM_TYPE_QUESTION.THREE_YEAR_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.FOUR_YEARS_OLD,
    value: ENUM_TYPE_QUESTION.FOUR_YEARS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.FIVE_YEARS_OLD,
    value: ENUM_TYPE_QUESTION.FIVE_YEARS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.SIX_YEARS_OLD,
    value: ENUM_TYPE_QUESTION.SIX_YEARS_OLD,
  },
];

// Kind of questionnaire. Each municipality code corresponds to one trial, so a
// municipality can publish its own version of any of these.
export const LIST_SURVEY_TYPE = [
  {
    text: MESSAGE_SURVEY_TYPE.EXAM,
    value: ENUM_SURVEY_TYPE.EXAM,
  },
  {
    text: MESSAGE_SURVEY_TYPE.SDQ,
    value: ENUM_SURVEY_TYPE.SDQ,
  },
  {
    text: MESSAGE_SURVEY_TYPE.MCHAT,
    value: ENUM_SURVEY_TYPE.MCHAT,
  },
  {
    text: MESSAGE_SURVEY_TYPE.DIPOLE,
    value: ENUM_SURVEY_TYPE.DIPOLE,
  },
  {
    text: MESSAGE_SURVEY_TYPE.YABUNAKA,
    value: ENUM_SURVEY_TYPE.YABUNAKA,
  },
  {
    text: MESSAGE_SURVEY_TYPE.KINDL,
    value: ENUM_SURVEY_TYPE.KINDL,
  },
  {
    text: MESSAGE_SURVEY_TYPE.PARENTING_SCALE,
    value: ENUM_SURVEY_TYPE.PARENTING_SCALE,
  },
  {
    text: MESSAGE_SURVEY_TYPE.CURIOSITY,
    value: ENUM_SURVEY_TYPE.CURIOSITY,
  },
  {
    text: MESSAGE_SURVEY_TYPE.SAFETY_ASSESSMENT,
    value: ENUM_SURVEY_TYPE.SAFETY_ASSESSMENT,
  },
];

// SDQ is resolved by age band rather than health-checkup timing.
export const LIST_TYPE_SURVEY_SDQ = [
  {
    text: MESSAGE_SURVEY_AGE.TWO_TO_FOUR_YEARS_OLD,
    value: ENUM_TYPE_QUESTION.TWO_TO_FOUR_YEARS_OLD,
  },
  {
    text: MESSAGE_SURVEY_AGE.FOUR_TO_SEVENTEEN_YEARS_OLD,
    value: ENUM_TYPE_QUESTION.FOUR_TO_SEVENTEEN_YEARS_OLD,
  },
];

export const CATEGORY_VIDEOS = {
  足踏み: ['同じ場所で動かすにできるか', '手と反対側の足が一緒に前にでるか', '足の上げ方・手の振り方に左右差がないか'],
  ボールキャッチ: [
    '腕を伸ばして大きなボールをキャッチする',
    '肘を90°曲げて体に着けて,掌を上に向けて胸を使ってキャッチする',
    '肩をリラックスさせ,肘を90°曲げて体に着け,胸を使わないで,両手の掌でキャッチする',
    '掌を上に向けて片方の手でテニスボールをキャッチする.左右実施する.',
    '手掌を前に向けて片方の手でテニスボールをキャッチする.左右実施する.',
  ],
  '寄り目＋追視・固視': [
    '両眼が動いているか',
    '動きに左右差がないか',
    '内側に動いていた眼球がある時点から外側に動かないか',
    'おもちゃが遠ざかる時もスムーズに眼球が外側に動くか',
    '頭を動かさずに目だけを動かせるか',
    '視線がぶれないか（正中線を超える時/視野の端から中央に戻す時）',
    '視線を10秒間動かさずに固定できるか',
  ],
  指の位置覚: [
    '年齢に応じた課題をクリアできるか',
    '指に力を入れずに形を作らせてくれるか',
    '隠された指の形を確認しようとして，指を強く押し付けあって触覚を使って指の位置を確認しようとしないか',
  ],
  'つま先上げ・つま先立ち': ['バランスを崩さずにスムーズにできるか', 'かかとに体重をかけた時に、ふらふらしないか', 'かかとは十分に上がっているか'],
  片脚立位保持: ['開眼での保持時間', '閉眼での保持時間'],
  継足歩行: ['線から外れた回数', '上半身が揺れていないか'],
  しゃがみ姿勢: ['指定された姿勢ができているか', '踵が浮いていないか'],
  つま先立ち保持: ['ステップせずに（足を動かさずに）保持できた時間', '床から踵が十分に上がっているか'],
  視覚性コピー: [
    '1胡座(あぐら)',
    '2投げ出し座り',
    '3四つ這い位',
    '4投げ出し座りで両手を一側の床の上に置く',
    '5投げ出し座りで一側の脚を曲げ,腕を組む',
    '6横坐りで一方の手を床に置き,他方の手を頭の上に置く',
  ],
  指折り: [
    '指示通り動かせるか',
    '指を一本一本独立して動かせるか',
    '素早くできるか',
    '数を数えながらできるか',
    '目を閉じて指を見ずにできるか',
    '左右差はないか',
  ],
  指まね: ['5つの形が全て作れるか'],
  図地判別: ['重なった図形の中で指定された図形の輪郭をなぞれているか'],
  テント: [
    '指の付け根を曲げた状態で指を伸ばせるか',
    'テーブルに手首をつけたままできるか（手首が上がってしまう場合が多い）',
    'テントをした時に手首が外側に曲がらないか',
    '高いテントを作れるか',
    '指を動かした時に形が崩れないか',
  ],
};

export const VIDEO_TUTORIAL = {
  足踏み: ['歩かずに,同じ場所で足踏みをする', '本番は3回までトライできる．1回目や2回目で実行できればその時点で検査終了．'],
  ボールキャッチ: [
    '【練習（課題の提示）】',
    '子どもは立ってキャッチする．',
    '①から⑤まで順番に課題を毎回見本を見せて，1回練習してから検査を行う．左右の手で実施する．2つ課題ができなかった時点で測定を終了する．',
    '',
    '大きなボールは2m前からキャッチしやすい位置に投げる',
    '（ボールが逸れた場合は再度投げ直す）．',
    'テニスボールは30㎝前から投げる（ボールが逸れた場合は再度投げ直す）．',
    '---',
    '①3歳：腕を伸ばして大きなボールをキャッチする',
    '②4歳：肘を90°曲げて体に着けて，掌を上に向けて胸を',
    '使ってキャッチする',
    '③5歳：肩をリラックスさせ，肘を90°曲げて体に着け，',
    '胸を使わないで，両手の掌でキャッチする',
    '④6歳：掌を上に向けて片方の手でテニスボールをキャッチ',
    'する．左右実施する．',
    '⑤7歳：手掌を前に向けて片方の手でテニスボールを',
    'キャッチする．左右実施する． ',
    '各課題を子どもは3回トライできる．左右の手で実施する．',
    '---',
    '2つ課題ができなかった時点で測定を終了する．',
  ],
  '寄り目＋追視・固視': [
    '子どもは3回トライできる．1回できればそれ以上のトライは行わない．',
    '顔の中央で眼から30cmの距離に置いた小さなおもちゃを,子どもの鼻に向かってゆっくりと動かす.それを見続けるように子どもに要求する．',
    '子どもに「指人形を左右と上下に動かすので，それをしっかりと見るよう」指示する．指人形を真ん中から右左・上下にゆっくりと動かし，視野の端で10秒間留め，固視と追視の評価を行う．',
    '30秒間休憩後，指標を真ん中→右斜め上→真ん中→斜め左上→真ん中→右斜め下→真ん中→左斜め下→真ん中とゆっくりと動かす．',
  ],
  指の位置覚: [
    '子どもの年齢に合わせて，片方の手または両手をボードで隠す．ボードはアシスタントの方に持ってもらう．指の形の①から順番に⑥まで指の形をコピーできるかを確認する．2つ続けてコピーできなかった時点で検査を終了する．左右の手で実施する．',
  ],
  'つま先上げ・つま先立ち': [
    'つま先立ち⇔つま先上げを10回（つま先上げを10回，つま先立ちを1回と数える）交互に繰り返す．',
    '',
    '子どもは3回トライする．10回以上できた時はその後のトライ',
    'は行わない．',
  ],
  片脚立位保持: [
    '片足でバランスを取ってなるべく長く立つ．',
    '【検査手順】',
    '子どもは3回トライする．30秒以上できた時はその後のトライは行わない（60秒で測定は中止する）．',
    '左右それぞれ開眼と閉眼で実施する．閉眼で行う前に閉眼の見本を見せる．',
  ],
  継足歩行: [
    '直線（またはテープ等）に貼られらテープから足を踏み外さずに歩く．本番は3回までトライできる．1回目や2回目で実行できればその時点で検査終了',
  ],
  しゃがみ姿勢: [
    '手を床に着くまたは床につけないで，踵を床に着けてしゃがみ姿勢を10秒間保持する．',
    '本番は3回までトライできる．1回目や2回目で実行できればその時点で検査終了．',
    '床に手を着けて，踵を床につけたままでしゃがむことを指示する．しゃがんだ後は，可能であれば手を床から離すように指示する．しゃがみ姿勢が10秒間保持できるかどうか検査する．',
    '床から手を離すと後方に倒れてしまった場合は，次は手を床に着いたまま10秒間しゃがめるか検査する．',
  ],
  つま先立ち保持: [
    'つま先立ちでステップしたり踵を床に着けないでつま先立ちをなるべく長く続ける．子どもは3回トライする．20秒以上できた時はその後のトライは行わない（60秒で測定は中止する）．',
  ],
  視覚性コピー: [
    '子どもは座る．①から⑥までの難易度別の姿勢のまねをする．練習無しで，真似をしてもらう．',
    '①胡座（あぐら）',
    '②投げ出し座り',
    '③四つ這い位',
    '④投げ出し座りで両手を一側の床の上に置く',
    '⑤投げ出し座りで一側の脚を曲げ,腕を組む',
    '⑥横坐りで一方の手を床に置き,他方の手を頭の上に置く',
  ],
  指折り: [
    '数を数えながら親指から順番に指を折り,小指から順番に指を開くよう子どもに要求する．左右別々に実施する．開眼と閉眼で実施する．',
    '開眼で右手→左手，閉眼で右手→左手の検査を行う．子どもは3回までトライできる．',
  ],
  指まね: [
    '子どもは3回トライできる．',
    '子どもの前に座って、右手で①から④（次頁）を作り、子どもにそれを真似るよう要求する。',
    '次頁の①から④の指の形が真似できるかを評価する．この時も対面で難しい場合は，提示方法の①から③の順番で提示方法を変更する．',
  ],
  図地判別: [
    '言葉ではなく，なぞる図形を別の紙で示す．',
    '【3～4歳】',
    '□→△→〇の順でなぞる．できた図形があればそれ以降の',
    '検査はしない．',
    '【5～6歳】',
    '☆→✜→△の順でなぞる．できた図形があればそれ以降の',
    '検査はしない．',
  ],
  テント: [
    '子どもは3回トライできる．',
    '①子どもが手で図の形が作れるかどうかを左右別々に検査する．',
    '②図の形を作ることができた子どもに対して，親指，人差し指，中指，小指を1本ずつ動かすことができるかを左右別々に評価する．',
  ],
};

export const DATA_KEYS_MOTOR_SKILLS = [
  [
    [
      {
        title: MESSAGE_MOTOR_SKILLS.COORDINATED_GROSS_MOTOR_SKILLS,
        key: 'coordinated_gross_motor_skills',
      },
      {
        title: MESSAGE_MOTOR_SKILLS.COORDINATED_FINE_MOTOR_SKILLS,
        key: 'coordinated_fine_motor_skills',
      },
    ],
  ],
  [
    [
      {
        title: MESSAGE_MOTOR_SKILLS.MOTOR_PLANNING,
        key: 'motor_planning',
      },
    ],
  ],
  [
    [
      {
        title: MESSAGE_MOTOR_SKILLS.BASIC_MOTOR_CAPACITY,
        children: [
          {
            title: MESSAGE_MOTOR_SKILLS.GROSS,
            key: 'gross',
          },
          {
            title: MESSAGE_MOTOR_SKILLS.FINE,
            key: 'fine',
          },
        ],
      },
      {
        title: MESSAGE_MOTOR_SKILLS.SURROUNDING_ENVIRONMENT_PERCEPTION,
        children: [
          {
            title: MESSAGE_MOTOR_SKILLS.EYE_MOVEMENT,
            key: 'eye_movement',
          },
          {
            title: MESSAGE_MOTOR_SKILLS.VISUAL_PERCEPTION,
            key: 'visual_perception',
          },
        ],
      },
    ],
  ],
  [
    [
      {
        children: [
          {
            title: MESSAGE_MOTOR_SKILLS.TOUCH,
            key: 'touch',
          },
          {
            title: MESSAGE_MOTOR_SKILLS.PROPRIOCEPTION,
            key: 'proprioception',
          },
          {
            title: MESSAGE_MOTOR_SKILLS.VESTIBULAR_SENSATION,
            key: 'vestibular_sensation',
          },
        ],
      },
    ],
    [
      {
        children: [
          {
            title: MESSAGE_MOTOR_SKILLS.SEPARATIVE_MOVEMENT,
            key: 'separative_movement',
          },
          {
            title: MESSAGE_MOTOR_SKILLS.COORDINATED_MOVEMENT,
            key: 'coordinated_movement',
          },
        ],
      },
    ],
    [
      {
        children: [
          {
            title: MESSAGE_MOTOR_SKILLS.MUSCLE_ENDURANCE,
            key: 'muscles',
          },
          {
            title: MESSAGE_MOTOR_SKILLS.RANGE_OF_MOVEMENT,
            key: 'range_of_movement',
          },
          {
            title: MESSAGE_MOTOR_SKILLS.BALANCE,
            key: 'balance',
          },
        ],
      },
    ],
  ],
];

export const MUNICIPALITY_CODE_VIETNAM = ['000000', '999999'];

export const CHUNK_SIZE = 2 * 1024 * 1024; // 2MB
